module.exports = ensureHeader;

function ensureHeader(headers, key, value) {
  var lower = key.toLowerCase();

  if (!headers[key] && !headers[lower]) {
    headers[key] = value;
  }
}